<template>
  <div :class="`innerWarp ${showAdd ? 'showAdd' : ''} ${addIsUser && showAdd ? 'noBelongData' : ''} ${hideContent ? 'hideContent' : ''} ${teamRe ? 'teamRe' : ''}`">
    <div class="banner">
      <!-- <div class="innerBgColor"></div> -->
      <div class="phoneIconRight"></div>
      <div class="phoneIconLeft"></div>
      <div class="museumName">{{$store.state.ticketDetail.ticketName}}</div>
      <div class="reTime">
        开馆时间：{{$store.state.ticketDetail.timeOpen}}-{{$store.state.ticketDetail.timeClose}}
        <span v-if="$store.state.ticketDetail.timeStop">停止入馆时间：{{$store.state.ticketDetail.timeStop}}</span>
      </div>
    </div>
    <div class="content" v-if="!hideContent">
      <slot></slot>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      museum: {},
      imageStateUrl: ''
    };
  },

  // 三种不同的样式
  props: ['showAdd', 'addIsUser', 'hideContent', 'teamRe'],

  methods: {
    getMuseum() {
      this.$ajax(`/api/admin/front/group/name?museumCode=${this.$store.state.museumCode}`).then((res) => {
        this.$store.state.museumName = res.data
      })
    },

    getticketDetail() {
      let url = this.$route.query.code ? `/api/ticket/front/ticket-info/code?museumCode=${this.$store.state.museumCode}&code=${this.$route.query.code}` : `/api/ticket/front/ticket-info?museumCode=${this.$store.state.museumCode}${this.$route.query.id ? `&ticketInfoId=${this.$route.query.id}` : ''}`
      this.$ajax.get(url).then((res) => {
        this.$store.state.ticketDetail = res.data[0]
      })
    },
  },

  created() {
    this.imageStateUrl = !isNaN(Number(this.$store.state.museumCode)) ? '' : Glob.imgUrl
  },

  mounted() {
    if (!this.$store.state.museumName) {
      this.$store.state.museumCode = this.$cookie.get('museumCode') || this.$route.query.museumCode || this.$store.state.museumCode
      this.getMuseum()
      if (!this.$store.state.ticketDetail.id){
        this.getticketDetail()
      }
    }
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
  .innerWarp{
    .banner{
      height: 4rem;
      width: 9rem;
      // background: url('~@/assets/innerBanner.png') 0 0/contain no-repeat;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: 0 0;
      position: fixed;
      top: 0;
      left: 0;
      z-index: -1;
      color: #fff;
      text-align: center;
      padding: 0 0.5rem;
      &:after{
        position: absolute;
        content: '';
        width: 6.24rem;
        height: 2.6rem;
        background: url('../../assets/ticket/re_topImg.png') 0 0/contain no-repeat;
        left: 2rem;
        bottom: 0;
      }
      .phoneIconRight{
        position: absolute;
        width:.36rem;
        height:1.1rem;
        background:url('../../assets/images/bannerIcon.png') no-repeat;
        background-size: 100%;
        top:.8rem;
        right:.8rem;
        transform:rotate(180deg)
      }
      .phoneIconLeft{
        position: absolute;
        width:.36rem;
        height:1.1rem;
        background:url('../../assets/images/bannerIcon.png') no-repeat;
        background-size: 100%;
        top: 2rem;
        left:.8rem;
      }
      .museumName{
        font-size: .6rem;
        margin-top: 0.45rem;
        font-weight: 500;
        line-height: .9rem;
        color: #fff;
        letter-spacing: .02em;
      }
      .reTime{
        width: auto;
        font-size: .3rem;
        padding: 0.13rem 0.7rem;
        background: rgba(255,228,188,.10196078431372549);
        border-radius: 0.1rem;
        display: inline-block;
        margin-top: 0.45rem;
        span{
          margin-left: 0.2rem;
        }
      }
    }
    .content{
      margin-top: 3.9rem;
      min-height: calc(100vh - 4.9rem);
      background-color: #fff;
      z-index: 2;
      padding: 0.5rem 0;
      position: relative;
    }
    // 个人信息添加
    &.noBelongData{
      .banner{
        display: none;
      }
      .content{
        margin-top: 0;
      }
    }
    // 团队详情，不滚动没有内容
    &.hideContent{
      position: relative;
      .banner{
        position: inherit;
        top: unset;
        left: unset;
        z-index: 0;
        // background: url('~@/assets/ticket/reservation_bg2.png') 0 0/contain no-repeat;
      }
      .museumName{
        margin-top: 0;
        padding-top: 0.45rem;
      }
    }
    // 团队预约换背景
    &.teamRe{
      .banner{
        // background: url('~@/assets/ticket/reservation_bg2.png') 0 0/contain no-repeat;
      }
    }
  }
</style>
